import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

export default function Clarity() {
    const { userInfo } = useAuth();

    useEffect(() => {
        if (!userInfo?.email_id) return;

        // Avoid loading twice
        if (!window.clarity) {
            (function (
                c: any,
                l: Document,
                a: string,
                r: string,
                i: string,
                t?: HTMLScriptElement,
                y?: Element
            ) {
                c[a] =
                    c[a] ||
                    function () {
                        (c[a].q = c[a].q || []).push(arguments);
                    };
                t = l.createElement(r) as HTMLScriptElement;
                t.async = true;
                t.src = "https://www.clarity.ms/tag/" + i;
                y = l.getElementsByTagName(r)[0];
                if (y && y.parentNode) {
                    y.parentNode.insertBefore(t, y);
                }
            })(window, document, "clarity", "script", "srh34drvq4");
        }

        // Set email after clarity is available
        if (window.clarity) {
            window.clarity("set", "email_id", userInfo.email_id);
        }
    }, [userInfo]);

    return null; // No UI, just loads the script
}
